import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0d2c54',
      light: '#3d5a82',
      dark: '#00001f',
    },
    secondary: {
      main: '#dbf14e',
      light: '#ffff80',
      dark: '#a7be00',
    },
  },
  typography: {
    fontFamily: "'General Sans', sans-serif",
    h1: { fontFamily: "'Chillax', sans-serif", fontWeight: 500 },
    h2: { fontFamily: "'Chillax', sans-serif", fontWeight: 500 },
    h3: { fontFamily: "'Chillax', sans-serif", fontWeight: 500 },
    h4: { fontFamily: "'Chillax', sans-serif", fontWeight: 500 },
    h5: { fontFamily: "'Chillax', sans-serif", fontWeight: 500 },
    h6: { fontFamily: "'Chillax', sans-serif", fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'Chillax', sans-serif",
          fontWeight: 500,
        },
        contained: {
          backgroundColor: '#dbf14e',
          color: '#121212',
          border: '2px solid #121212',
          borderRadius: '100px',
          '&:hover': {
            backgroundColor: '#c8dc45',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#0d2c54',
          '&.Mui-checked': {
            color: '#0d2c54',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#0d2c54',
          '&.Mui-checked': {
            color: '#0d2c54',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#121212',
          fontFamily: "'General Sans', sans-serif",
          '&.Mui-focused': {
            color: '#0d2c54',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0d2c54',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#0d2c54',
          },
        },
      },
    },
  },
});

export default theme;